import { __awaiter } from "tslib";
import { BaseService } from "@/servicesTs/base";
export class MedicalAdmissionService extends BaseService() {
    static get entity() {
        return "medical_admission";
    }
    static get responseName() {
        return "medical_admission";
    }
    /**
     *
     * @param data.state se saca del medical_admission
     * @param data.rut
     * @param data.node_id se saca del service_node
     * @param data.medical_admission_id hace referencia al Id
     * @param data.patient_name
     * @param data.patient_apepat
     * @param data.patient_apemat
     */
    static getFilter(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `filter`,
                data: data,
            });
        });
    }
    static getFilterNoPaginated(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `filter`,
                data: data,
            });
        });
    }
    /**
     *
     * @param data.request_date_start
     * @param data.request_date_end
     * @param data.medical_admission_id
     */
    static filterMaActivityByRangeDate(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `filter_ma_activity_by_range_date`,
                data: data,
            });
        });
    }
    static storeNewConsultation(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `store_new_consultation`,
                data: data,
                showFullResponse: true,
            });
        });
    }
}
